/* CBS DECOR feature layer — back-to-top, sticky buy bar, colour swatches,
   recently viewed, m² calculator, mega-menu promos. Additive; no Dawn JS is modified. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------------- Back to top ---------------- */
  function backToTop() {
    var btn = document.createElement('button');
    btn.className = 'cbs-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML =
      '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M7 12V2M2.5 6.5 7 2l4.5 4.5"/></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(btn);
    var onScroll = function () {
      btn.classList.toggle('is-visible', window.scrollY > 1200);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Sticky buy bar ---------------- */
  function stickyBuyBar() {
    if (!document.querySelector('main [data-template="product"], main[data-template="product"]')) return;
    var form = document.querySelector('.product-form form, product-form form');
    var submit = document.querySelector('.product-form__submit');
    var titleEl = document.querySelector('.product__title h1, .product__title .h1, .product__info-container h1');
    var priceEl = document.querySelector('.product__info-container .price__regular .price-item, .product__info-container .price-item--regular');
    var img = document.querySelector('.product__media img');
    if (!submit || !titleEl) return;

    var bar = document.createElement('div');
    bar.className = 'cbs-buybar';
    bar.innerHTML =
      (img ? '<img class="cbs-buybar__img" src="' + img.currentSrc + '" alt="">' : '') +
      '<div class="cbs-buybar__meta"><p class="cbs-buybar__title"></p><p class="cbs-buybar__price"></p></div>' +
      '<button type="button" class="button">Add to cart</button>';
    bar.querySelector('.cbs-buybar__title').textContent = titleEl.textContent.trim();
    if (priceEl) bar.querySelector('.cbs-buybar__price').textContent = priceEl.textContent.trim();
    bar.querySelector('button').addEventListener('click', function () {
      submit.click();
      submit.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
    document.body.appendChild(bar);

    var io = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      },
      { threshold: 0 }
    );
    io.observe(submit);
  }

  /* ---------------- Colour swatches on cards ---------------- */
  function swatches() {
    var grids = document.querySelectorAll('.product-grid, .grid.contains-card--product');
    if (!grids.length) return;
    fetch(window.cbsSiblingsUrl)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        var decorate = function (root) {
          root.querySelectorAll('.card-wrapper').forEach(function (card) {
            if (card.dataset.cbsSwatched) return;
            var link = card.querySelector('.card__heading a[href*="/products/"]');
            if (!link) return;
            var m = link.getAttribute('href').match(/\/products\/([a-z0-9-]+)/);
            if (!m) return;
            var info = data.products[m[1]];
            if (!info) return;
            var group = data.groups[info.g];
            if (!group || group.length < 2) return;
            card.dataset.cbsSwatched = '1';
            var wrap = document.createElement('div');
            wrap.className = 'cbs-swatches';
            wrap.setAttribute('aria-label', 'Available colours');
            group.slice(0, 7).forEach(function (sib) {
              var a = document.createElement('a');
              a.className = 'cbs-swatch';
              a.href = '/products/' + sib.h;
              a.title = sib.c;
              a.setAttribute('aria-label', sib.c);
              a.style.backgroundColor = data.colors[sib.c] || '#999';
              if (sib.h === m[1]) a.setAttribute('aria-current', 'true');
              wrap.appendChild(a);
            });
            if (group.length > 7) {
              var more = document.createElement('a');
              more.className = 'cbs-swatch cbs-swatch--more';
              more.href = '/products/' + m[1];
              more.textContent = '+' + (group.length - 7);
              wrap.appendChild(more);
            }
            var target = card.querySelector('.card__information .card-information') ||
                         card.querySelector('.card__information');
            if (target) target.appendChild(wrap);
          });
        };
        grids.forEach(decorate);
        new MutationObserver(function () { grids.forEach(decorate); })
          .observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  /* ---------------- Recently viewed ---------------- */
  var RV_KEY = 'cbs:recent';

  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function recentlyViewed() {
    var main = document.querySelector('main [data-template], main[data-template]');
    var isProduct = main && main.dataset.template === 'product';
    var current = null;

    if (isProduct) {
      var t = document.querySelector('.product__title h1, .product__info-container h1');
      var img = document.querySelector('.product__media img');
      var price = document.querySelector('.product__info-container .price-item--regular');
      var handleM = location.pathname.match(/\/products\/([a-z0-9-]+)/);
      if (t && handleM) {
        current = {
          h: handleM[1],
          t: t.textContent.trim(),
          img: img ? img.currentSrc : '',
          p: price ? price.textContent.trim() : ''
        };
      }
    }

    var list = readRecent().filter(function (x) { return !current || x.h !== current.h; });
    var toShow = list.slice(0, 8);

    if (isProduct && toShow.length >= 2) {
      var sec = document.createElement('section');
      sec.className = 'cbs-recent page-width';
      sec.innerHTML = '<div class="cbs-recent__head"><h2>Recently viewed</h2></div><div class="cbs-recent__row"></div>';
      var row = sec.querySelector('.cbs-recent__row');
      toShow.forEach(function (x) {
        var a = document.createElement('a');
        a.className = 'cbs-recent__item';
        a.href = '/products/' + x.h;
        a.innerHTML = '<div class="cbs-recent__imgwrap"><img loading="lazy" alt=""></div><span class="t"></span><span class="p"></span>';
        a.querySelector('img').src = x.img;
        a.querySelector('.t').textContent = x.t;
        a.querySelector('.p').textContent = x.p;
        row.appendChild(a);
      });
      var host = document.getElementById('MainContent') || document.querySelector('main');
      if (host) host.appendChild(sec);
    }

    if (current) {
      list.unshift(current);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {}
    }
  }

  /* ---------------- m² calculator (flooring products) ---------------- */
  function calculator() {
    var main = document.querySelector('main [data-template], main[data-template]');
    if (!main || main.dataset.template !== 'product') return;
    var typeEl = document.querySelector('.product__info-container');
    if (!typeEl) return;
    var text = document.body.textContent || '';
    var isFlooring = /laminate flooring|vinyl flooring|spc|engineered (hardwood|wooden|wood) floor|herringbone/i
      .test(document.title + ' ' + (document.querySelector('.product__title') || {}).textContent);
    if (!isFlooring) return;

    var desc = document.querySelector('.product__description');
    var coverage = null;
    if (desc) {
      var cm = desc.textContent.replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*m(?:²|2)\s*(?:per|\/)?\s*(?:pack|box|carton)?/i);
      if (cm) {
        var v = parseFloat(cm[1]);
        if (v > 0.5 && v < 6) coverage = v;
      }
    }

    var box = document.createElement('div');
    box.className = 'cbs-calc';
    box.innerHTML =
      '<p class="cbs-calc__label">How much do I need?</p>' +
      '<div class="cbs-calc__row">' +
      '<label>Room length (m)<input type="number" min="0" step="0.1" inputmode="decimal"></label>' +
      '<label>Room width (m)<input type="number" min="0" step="0.1" inputmode="decimal"></label>' +
      '</div><p class="cbs-calc__out" aria-live="polite"></p>' +
      '<p class="cbs-calc__note">Includes an 8% cutting and waste allowance.</p>';
    var inputs = box.querySelectorAll('input');
    var out = box.querySelector('.cbs-calc__out');
    var update = function () {
      var l = parseFloat(inputs[0].value), w = parseFloat(inputs[1].value);
      if (!(l > 0) || !(w > 0)) { out.textContent = ''; return; }
      var need = l * w * 1.08;
      var msg = 'You need about <strong>' + need.toFixed(1) + ' m²</strong>';
      if (coverage) msg += ' — <strong>' + Math.ceil(need / coverage) + ' packs</strong> at ' + coverage + ' m² per pack';
      out.innerHTML = msg + '.';
    };
    inputs.forEach(function (i) { i.addEventListener('input', update); });

    var anchor = document.querySelector('.product-form__buttons') ||
                 document.querySelector('.product__description');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor);
  }

  /* ---------------- Mega menu promo tiles ---------------- */
  function megaPromos() {
    if (!window.cbsMegaPromos) return;
    document.querySelectorAll('header-menu > details, .header__inline-menu details').forEach(function (d) {
      var label = (d.querySelector('summary') || {}).textContent || '';
      label = label.trim();
      var conf = window.cbsMegaPromos[label];
      if (!conf) return;
      var content = d.querySelector('.mega-menu__content .page-width, .mega-menu__content');
      if (!content || content.querySelector('.cbs-mega-promo')) return;
      var list = content.querySelector('.mega-menu__list');
      if (!list) return;
      var a = document.createElement('a');
      a.className = 'cbs-mega-promo';
      a.href = conf.url;
      a.innerHTML = '<img loading="lazy" alt=""><span class="k"></span><span class="v"></span>';
      a.querySelector('img').src = conf.img;
      a.querySelector('img').alt = conf.title;
      a.querySelector('.k').textContent = conf.kicker;
      a.querySelector('.v').textContent = conf.title;
      list.appendChild(a);
    });
  }

  ready(function () {
    backToTop();
    stickyBuyBar();
    swatches();
    recentlyViewed();
    calculator();
    megaPromos();
  });
})();
